import axios from "axios";
import store from "../store/index";
import router from "../router/index";
import Vue from "vue";
import VueToast from "vue-toast-notification";

Vue.use(VueToast, {
  position: "top",
  duration: 3000,
  dismissible: true,
  queue: true
});

export default function execute() {
  axios.interceptors.request.use(
    function(config) {
      const token = store.state.user.token;
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    },
    function(err) {
      return Promise.reject(err);
    }
  );
  axios.interceptors.response.use(null, error => {
    if (error.config && error.response && error.response.status === 401) {
      // handling the unauthorized response scenario
      store.dispatch("logout").then(() => {
        router.push('/signin');
      });
    } else if (
      error.config &&
      error.response &&
      error.response.status === 404
    ) {
      // handling the resource not found scenario
      Vue.$toast.error("No result found.");
    } else if (
      error.config &&
      error.response &&
      error.response.status === 500
    ) {
      // handling the API malfunction/fault scenario
      Vue.$toast.error(
        "Unable to execute the process. Please try again later."
      );
    }
    return Promise.reject(error);
  });
}
